import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { OperationTLR } from '../entities/operation-tlr.entity';
import { OperationCreate } from '../entities/operation-create.entity';
import { OperationUpdate } from '../entities/operation-update.entity';
import { ExtendedOperationDTO } from '../entities/extended-operation-dto.entity';

@Injectable({ providedIn: 'root' })
export class OperationService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: OperationService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	public getOperationsByParcAndClasse(parcId: number, classeId: number, anneeDebut: number, anneeFin: number, recurrence: boolean | undefined): Observable<ExtendedOperationDTO[]> {
		let url = this.path + "operations?format=DTO&parc=" + parcId + "&classe=" + classeId + "&debut=" + anneeDebut + "&fin=" + anneeFin;
		if (recurrence != undefined) {
			url += "&recurrence=" + recurrence;
		}
		let result = this.httpClient //
			.get<ExtendedOperationDTO[]>(url) //
		;

		return result;
	}
	
	public getOperationsByParcAndClasseAndActeParent(parcId: number, classeId: number, typeMaintenanceId: number): Observable<ExtendedOperationDTO[]> {
		let url = this.path + "operations?format=DTO&parc=" + parcId + "&classe=" + classeId + "&acte-parent=" + typeMaintenanceId;
		let result = this.httpClient //
			.get<ExtendedOperationDTO[]>(url) //
		;

		return result;
	}

	public getOperationById(operationId: number): Observable<OperationTLR> {
		let url = this.path + "operations/" + operationId;
		let result = this.httpClient //
			.get<OperationTLR>(url) //
		;

		return result;
	}
	
	public createOperation(operation: OperationTLR): Observable<OperationTLR> {
		const url = this.path + 'operations';
		const request$ = this.httpClient.post<OperationTLR>(url, operation, {});
		return request$;
	}
	
	public createOperations(creationData: OperationCreate): Observable<void> {
		const url = this.path + 'operations/orders/mass-creation';
		const request$ = this.httpClient.post<void>(url, creationData, {});
		return request$;
	}
	
	public closeOperation(operationId: number): Observable<void> {
		const url = this.path + 'operations/orders/close/' + operationId;
		const request$ = this.httpClient.post<void>(url, {}, {});
		return request$;
	}
	
	public reopenOperation(operationId: number): Observable<void> {
		const url = this.path + 'operations/orders/reopen/' + operationId;
		const request$ = this.httpClient.post<void>(url, {}, {});
		return request$;
	}
	
	public updateOperation(updateData: OperationUpdate): Observable<void> {
		const url = this.path + 'operations/orders/update';
		const request$ = this.httpClient.post<void>(url, updateData, {});
		return request$;
	}
	
	public deleteOperation(id: number): Observable<void> {
		const url = this.path + 'interventions/' + id;
		const request$ = this.httpClient.delete<void>(url, {});
		return request$;
	}
}